import React from 'react'
import healthcare1 from '../images/ironBridge.png';
import healthcare2 from '../images/ironBridge1.png';
import healthcare3 from '../images/coresync3.png';
import OurPartner from '../pages/components/OurPartner';

function IronBridge() {
    return (
        <>
            <section id="portfolio" className="container my-5">
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="px-3 fw-bold responsive-heading">
                        <span className="highlight-orange">IronBridge</span> – Custom Logistics Management Software Designed for IronBridge
                    </div>
                </div>
            </section>

            <section className="container my-5">
                {/* Section 1: Project Overview */}
                <div className="row g-0 overflow-hidden shadow rounded">
                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare1}
                            alt="Remente App Overview"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">IronBridge</span> – Custom Logistic Management Software
                        </h1>

                        <p className="mb-3 ps-1">
                            IronBridge is a tailored logistic management software solution designed to streamline end-to-end logistics operations,
                            automate workflow processes, and provide real-time visibility across the entire supply chain. It helps organizations
                            reduce operational bottlenecks, enhance coordination, and deliver faster, more reliable logistics performance.
                        </p>

                        <p className="mb-3 ps-1">
                            With smart shipment tracking, automated fleet and warehouse management, expense and route optimization, and data-driven insights,
                            IronBridge empowers logistics teams to operate with precision, improve efficiency, and scale operations through a fully integrated
                            digital platform.
                        </p>


                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>
                </div>

                {/* Section 2: Summary & Team Info */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">Client:</span> IronBridge
                        </h1>

                        <h4 className="fw-bold mb-1 highlight-orange">Country</h4>
                        <p className="mb-3 ps-3">USA</p>

                        <h4 className="fw-bold mb-1 highlight-orange">Technology & Purpose</h4>
                        <p className="mb-3 ps-3">
                            Custom Logistic Automation Engine, Fleet & Warehouse Workflow Management, Route Optimization System,
                            React, Node.js, Firebase, REST APIs, Real-Time Tracking Modules, Analytics Dashboard, Automated Alerts & Reports
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Domain</h4>
                        <p className="mb-3 ps-3">Logistics & Supply Chain Automation</p>

                        <h4 className="fw-bold mb-1 highlight-orange">Team Involvement</h4>
                        <p className="mb-3 ps-3">
                            UI/UX Designer, 2 Frontend Engineers, Backend Architect, Logistic Workflow Specialist,
                            Automation Engineer, QA Engineer
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Duration</h4>
                        <p className="mb-4 ps-3">5 Months</p>

                        <p className="mb-4 ps-3">
                            IronBridge is a custom-built logistic management platform designed to modernize and automate logistics operations,
                            including fleet tracking, warehouse coordination, shipment scheduling, and route optimization.
                            The system provides real-time visibility across the supply chain, ensuring smooth communication between teams
                            and reducing operational delays.
                            <br /><br />
                            With automated alerts, AI-assisted planning, live tracking modules, and an advanced analytics dashboard,
                            IronBridge enables logistics teams to improve delivery accuracy, optimize resource utilization, and reduce overall operational costs.
                            Its integrated workflow engine ensures seamless coordination across drivers, dispatch teams, warehouses, and clients.
                        </p>



                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>

                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare2}
                            alt="Remente UI"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>
                </div>

                {/* Section 3: Process & Key Features */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare3}
                            alt="Mental Wellness Features"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3">
                            <span className="highlight-orange">Process</span>
                        </h1>

                        <p className="mb-3 ps-1">
                            We built the IronBridge Logistic Management System with a logistics-first architecture designed for automation,
                            workflow accuracy, and real-time operational control. The platform integrates fleet management, warehouse coordination,
                            shipment tracking, route optimization, and dispatch workflows into a unified ecosystem. Our backend ensures reliable
                            real-time data processing, secure communication between modules, and seamless synchronization across drivers, warehouses,
                            and administrative teams.
                        </p>

                        <p className="mb-3 ps-1">
                            The UI/UX was designed to simplify complex logistics operations and make automation effortless for teams of all sizes.
                            A clean, intuitive, and role-based interface allows dispatchers, warehouse managers, and fleet operators to monitor
                            shipments, assign tasks, track vehicles, and manage workflows efficiently — without requiring technical expertise.
                        </p>

                        <h4 className="fw-bold mb-2 highlight-orange">Key Features</h4>
                        <ul className="ps-3 mb-4">
                            <li className="mb-1">Automated dispatch & workflow management</li>
                            <li className="mb-1">Real-time fleet tracking with route optimization</li>
                            <li className="mb-1">Smart warehouse coordination with inventory linkage</li>
                            <li className="mb-1">Shipment scheduling with automated status updates</li>
                            <li className="mb-1">Advanced analytics dashboard for delivery performance & delays</li>
                            <li className="mb-1">Centralized communication system for drivers & dispatch teams</li>
                        </ul>



                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Get Started
                        </a>
                    </div>
                </div>

                <OurPartner />
            </section>

        </>
    )
}

export default IronBridge